import _slicedToArray from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { throttle } from '../utils/promise-utils';
import { chain, path, prop, uniqBy } from 'ramda';
import { urls } from '../config.js';
import withAxios from '../utils/with-axios';
var LAT_LNG_PRECISION = 3; // decimal places

/**
 * Rounds a number UP to the specified precision
 *
 * @param {int} dp number of decimal places
 */
var ceilingTo = function ceilingTo(dp) {
  return function (x) {
    var factor = Math.pow(10, dp); // eslint-disable-line no-magic-numbers
    return Math.ceil(x * factor) / factor;
  };
};
var flattenTiles = function flattenTiles(tiles) {
  return uniqBy(prop('id'), chain(prop('pins'), tiles));
};

/**
 * Takes a box drawn with lat / lng and returns a list of all map tiles within
 * these bounds
 *
 * @param {float} north The bounding limit of the latitude to the north
 * @param {float} south The bounding limit of the latitude to the south
 * @param {float} east The bounding limit of the latitude to the east
 * @param {float} west The bounding limit of the latitude to the west
 */
var tilesWithin = throttle(function (axios) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  var _params$map = params.map(ceilingTo(LAT_LNG_PRECISION)),
    _params$map2 = _slicedToArray(_params$map, 4),
    north = _params$map2[0],
    south = _params$map2[1],
    east = _params$map2[2],
    west = _params$map2[3];
  var endpoint = urls.apiV2("/tiles/".concat(north, ",").concat(west, ":").concat(south, ",").concat(east));
  return axios.get(endpoint, {
    params: {
      platform: 'app'
    }
  }).then(path(['data', 'data']));
});

/**
 * Takes a box drawn with lat / lng and returns a list of all locations within
 * these bounds
 *
 * @param {float} north The bounding limit of the latitude to the north
 * @param {float} south The bounding limit of the latitude to the south
 * @param {float} east The bounding limit of the latitude to the east
 * @param {float} west The bounding limit of the latitude to the west
 */
var locationsWithin = function locationsWithin(axios, north, south, east, west) {
  return tilesWithin(axios, north, south, east, west).then(flattenTiles);
};
export default {
  tilesWithin: withAxios(tilesWithin),
  locationsWithin: withAxios(locationsWithin)
};